import { render, staticRenderFns } from "./HomeProfileCompletionWarning.vue?vue&type=template&id=b78711fc&"
var script = {}
import style0 from "./HomeProfileCompletionWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports